const initialState = {
    toggleConfirm: false,
    pendingConfirmationAction: null,
    message: '',
    param: null
};

export default function ConfirmDialogReducer(state = initialState, action) {
    switch (action.type) {
        case 'REQUEST_CONFIRMATION':
            const {pendingConfirmationAction, message, param} = action;
            return {
                toggleConfirm: true,
                pendingConfirmationAction,
                message,
                param
            };
        case 'CANCEL':
            return {
                toggleConfirm: false
            }
        case 'CONFIRM':
            return {
                toggleConfirm: false
            };
        default:
            return state;
    }
}